import React, { useState } from 'react'
import './styles.scss'
import arrow from './../../images/arrow.svg'
import arrowBlack from './../../images/arrow-next-blue.svg'
import arrowPrev from './../../images/arrow-prev.svg'
import add from './../../images/add.svg'
import minus from './../../images/minus-ico.svg'
import download from './../../images/download-ico.svg'
import downloadWhite from './../../images/download-white-ico.svg'
import arrowPrevBlack from './../../images/arrow-prev-blue.svg'
import info from './../../images/i-ico-blue.svg'
import ModalMessage from '../modal-message/ModalMessage';

const Button = ( props ) => {
    let [ activeModal, setActiveModal ] = useState(false);

    let keyPressed = e => {
        if (e.key === "Enter") {
          props.setFunction()
        }
    }

    return (
        <div id={props.id && props.id} className={( props.tip ? 'have-tip' : '') + " btn-wrap" }>
            <div className={"btn " + props.class  + ( props.disabled ? ' disabled' : '')}  role="button" tabindex="0" onClick={ () => props.setFunction() } onKeyPress={ (e) => keyPressed(e)}>
                { props.title }
                { props.arrow && 
                    <img className="arrow" src={ arrow } alt="Oblicz ratę"/>
                }
                { props.arrowBlack && 
                    <img className="arrow" src={ arrowBlack } alt="Oblicz ratę"/>
                }
                { props.arrowPrev && 
                    <img className="arrow prev" src={ arrowPrev } alt="Powrót"/>
                }
                { props.arrowPrevBlack && 
                    <img className="arrow-prev" src={ arrowPrevBlack } alt="Powrót"/>
                }
                { props.add && 
                    <img className="add" src={ add } alt="Dodaj"/>
                }
                { props.minus && 
                    <img className="minus" src={ minus } alt="Usuń"/>
                }
                { props.download && 
                    <img className="upload-ico" src={ download } alt="download"/>
                }
                { props.downloadWhite && 
                    <img className="upload-ico" src={ downloadWhite } alt="download"/>
                }
            </div>
            { props.tip && 
                <img src={ info } className="tip" alt="informacja" onClick={ () => setActiveModal( true )} />
            }
            { activeModal &&
                <ModalMessage   closeModal={ () => setActiveModal(false) } 
                                button={ props.button } 
                                buttonClass="blue" 
                                buttonTitle={ props.buttonTitle }
                                buttonArrow={ true } 
                                tipHeader={ props.tipHeader }
                                tipText={ props.tipText } />
            }
        </div>
    )
}

export default Button;